export default __webpack_public_path__ + "static/media/coupang_logo.006ebdbc.png";